function findDeviceModel(modelData, manufacturer, modelnumber) {
    // tvModelsJson: tvModel;eanCode;manufacturer;feature_sat;feature_ip
    // Only use the model number to find a match.
    return modelData.find((tv) => tv.tvModel === modelnumber);
}

function getDeviceManufacturers(modelData) {
    const allManufacturers = modelData.map((model) => model.manufacturer);
    const manufacturersDeduped = new Set(allManufacturers);

    return [...manufacturersDeduped];
}

function getDeviceModels(modelData, manufacturerValue) {
    if (manufacturerValue) {
        const allManufacturerModel = modelData.filter(model => model.manufacturer === manufacturerValue);
        const allModels = allManufacturerModel.map((model) => model.tvModel);
        const manufacturerModelsDeduped = new Set(allModels);
        
        return [...manufacturerModelsDeduped];
    } else {
        const allModels = modelData.map((model) => model.tvModel);
        const modelsDeduped = new Set(allModels);

        return [...modelsDeduped];
    }

}

export { findDeviceModel, getDeviceManufacturers, getDeviceModels };
